module.exports = "/images/Get more foot traffic.svg?f973b4822431af554a382cbea16d4a74";